<header class="navbar navbar-expand-lg navbar-light navbar-static-top">
    <div class="navbar-header nav_bar">
        <a href="javascript:void(0)" (click)="changeMobileMenuState()"
            class="sidebar-mobile-toggler float-left d-lg-none" style="color: #0b7ad1;"><i class="ti-align-justify"></i>
        </a>
        <a class="navbar-brand image_parent_layout" href="javascript:void(0)"><img src="assets/images/ChatstasyCorpLogoAndSlogan-New.png"
                class="image_layout" alt="Chatstasy">
        </a>
        <a href="javascript:void(0)" (click)="changeState()"
            class="sidebar-toggler float-right d-none d-lg-block d-xl-block" style="color: #0b7ad1;"><i
                class="ti-align-justify"></i>
        </a>

    </div>
    <div class="container-navbar-right" style="padding-right: 10px;">
        <ul class="navbar-right">
            <li class="dropdown">
                <p-messages *ngIf="noInternetConnection" class="alignCenter">
                    <ng-template pTemplate>
                        <i class="pi pi-info-circle" style="font-size: 2rem;color: red;"></i>
                        <div class="p-ml-2 d-none d-md-block d-lg-block d-xl-block" style="color: red;">No Internet
                            Connection</div>
                    </ng-template>
                </p-messages>
            </li>
            <li class="dropdown">
                <a href="javascript:void(0)" class="dropdown-toggle" style="opacity: 1;"
                    (click)="openClientCommunication()">
                    <!-- <span class="dot-badge partition-red animated infinite pulse"></span> -->
                    <span *ngIf="messageCount != '0'" class="badge badge-pill badge-danger">{{messageCount}}</span>
                    <i style="color: #0b7ad1;" class="ti-comment animated bounce"></i>
                    <span class="d-none d-md-block d-lg-block d-xl-block">MESSAGES</span>
                </a>
            </li>
            <li class="dropdown">
                <a href="javascript:void(0)" (click)="setIsVisibleSidebar(true)" class="dropdown-toggle"
                    style="opacity: 1;">
                    <!-- <span class="dot-badge partition-red animated infinite pulse"></span> -->
                    <span *ngIf="notificationCount != '0'"
                        class="badge badge-pill badge-danger">{{notificationCount}}</span>
                    <i style="color: #0b7ad1;" class="ti-bell animated bounce"></i>
                    <span class="d-none d-md-block d-lg-block d-xl-block">Notification</span>
                </a>
            </li>
            <li class="dropdown current-user ">
                <a href="javascript:void(0)" (click)="menu.toggle($event)" class="dropdown-toggle"
                    data-toggle="dropdown">
                    <img [src]="profileUrl" [alt]="avatarName" (error)="fileFailedToLoad($event)">
                    <!-- <p-avatar *ngIf="imageInputError" class="avatar_style" [label]="avatarName">
                    </p-avatar> -->
                    <span class="username">{{firstName}} {{lastName}} <i class="ti-angle-down"></i></span>
                </a>
            </li>
        </ul>
    </div>

</header>
<p-menu #menu [popup]="true" [model]="items" [style]="{'width':'230px'}" styleClass="dark-panel">
</p-menu>